
    @if (_calculatedPrice) {
      @if(_calculatedPrice?.discountincvat === 0){
        @if(_calculatedPrice?.priceincvat === 0 && !_couponcodeItem && !_compensationItem){
          <small>{{'order.product_currently_not_available' | translate}}</small>
        }@else {
          <div @collapse class="flex flex-col items-end text-right">
            <small>{{_calculatedPrice?.priceincvat |currency: 'EUR':'symbol':'.2-2':'nl'}}</small>
          </div>
        }
        
    }@else {
          <div @collapse class="flex flex-col items-end text-right">
            <small><i class="line-through"> {{_calculatedPrice?.priceincvat + _calculatedPrice?.discountincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} </i></small>
            <strong><small>{{_calculatedPrice?.priceincvat   |currency: 'EUR':'symbol':'.2-2':'nl'}}</small></strong>
          </div>
    }
  }


